<template>
  <div class="mt-4">

    <tnm-stage-selector :branchId.sync="branchId"> </tnm-stage-selector>

    <div class="row">
      <div
          v-if="branchId !== null"
          class="col-xl-12 col-lg-8 col-md-8 col-sm-12 col-12 mb-4 mt-2"
      >
        <app-tool-selector
            :branchId="branchId"
            :toolId="toolId"
            :toolOpinion="toolOpinion"
            v-model="toolId"
        />
      </div>
    </div>

    <!--QUESTIONS  -->
    <div v-if="toolId !== null && toolOpinion !== null" class="row">
      <div class="col">
        <h4 class="">
          Prerequisite to be eligible for selected treatment
        </h4>
      </div>
    </div>

    <div v-if="toolId !== null && toolOpinion !== null" class="row">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3 mb-5"
        v-if="!toolOpinion.ignoreTool"
      >
        <!--Treatment History -->
        <div>
          <h5>Conditions</h5>

          <div class="mb-2">
            <strong>Non Re-challenge Scenario</strong>
          </div>
          <div class="row">
            <label class="col-6">
              <span>Treatment can be given in which lines?</span>
              <span class="ml-1" v-if="toolOpinion.mustBeGivenInHint">
              <b-icon-question-circle-fill class="question-hint" :id="`popover-target-mustBeGivenIn`"></b-icon-question-circle-fill>
            </span>

              <b-popover v-if="toolOpinion.mustBeGivenInHint" :target="`popover-target-mustBeGivenIn`" triggers="hover" placement="top">
                {{ toolOpinion.mustBeGivenInHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <v-select
                id="canBeGivenLines"
                :options="availableLines"
                label="Text"
                code="Line"
                multiple
                placeholder="Select Line(s)"
                v-model="mustBeGivenInLines"
              >
              </v-select>
            </div>
          </div>

          <div class="row mt-2">
            <label class="col-6">
              <span>Must not be given after</span>
              <span class="ml-1" v-if="toolOpinion.mustNotBeGivenAfterHint">
              <b-icon-question-circle-fill class="question-hint" :id="`popover-target-mustNotBeGivenAfter`"></b-icon-question-circle-fill>
            </span>

              <b-popover v-if="toolOpinion.mustNotBeGivenAfterHint" :target="`popover-target-mustNotBeGivenAfter`" triggers="hover" placement="top">
                {{ toolOpinion.mustNotBeGivenAfterHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <div
                v-for="(treatment, index) in mustNotBeGivenAfter"
                class="mb-2"
                :key="index"
              >
                <v-select
                  :options="allTreatments"
                  label="name"
                  code="id"
                  placeholder="Select Treatment"
                  :value="treatment"
                  @input="value => selectTreatment(value, treatment, index)"
                >
                </v-select>
              </div>

              <div class="mt-2">
                <span
                  class="link"
                  v-on:click="addTreatment"
                  :class="!canAddNewTreat ? 'disable-link' : ''"
                  >+Add Treatment</span
                >
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <label class="col-6">
              <span>Must be given after</span>
              <span class="ml-1" v-if="toolOpinion.mustBeGivenAfterHint">
              <b-icon-question-circle-fill class="question-hint" :id="`popover-target-mustBeGivenAfter`"></b-icon-question-circle-fill>
            </span>

              <b-popover v-if="toolOpinion.mustBeGivenAfterHint" :target="`popover-target-mustBeGivenAfter`" triggers="hover" placement="top">
                {{ toolOpinion.mustBeGivenAfterHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <div
                v-for="(treatment, index) in mustBeGivenAfter"
                class="mb-2" 
                :key="index"
              >
                <v-select
                  :options="allTreatments"
                  label="name"
                  code="id"
                  placeholder="Select Treatment"
                  :value="treatment"
                  @input="value => selectTreatmentMustBeGiven(value, treatment, index)"
                >
                </v-select>
              </div>

              <div class="mt-2">
                <span
                  class="link"
                  v-on:click="addTreatmentMustBeGiven"
                  :class="!canAddNewTreatMustBeGiven ? 'disable-link' : ''"
                  >+Add Treatment</span
                >
              </div>
            </div>
          </div>

          <div class="mb-2">
            <strong>Re-challenge Scenario</strong>
          </div>

          <div class="row  mt-2">
            <label class="col-6">
              <span>Was well tolerated</span>
              <span class="ml-1" v-if="toolOpinion.hasToBeToleratedHint">
                <b-icon-question-circle-fill class="question-hint" :id="`popover-target-hasToBeTolerated`"></b-icon-question-circle-fill>
              </span>

              <b-popover v-if="toolOpinion.hasToBeToleratedHint" :target="`popover-target-hasToBeTolerated`" triggers="hover" placement="top">
                {{ toolOpinion.hasToBeToleratedHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <v-select
                id="hasToBeToleratedLocal"
                :options="toleratedButtons"
                label="Text"
                code="Line"
                v-model="hasToBeToleratedLocal"
                placeholder="Select Option"
              >
              </v-select>
            </div>
          </div>

          <div  class="row  mt-2">
            <label class="col-6">
              <span> Was effective</span>
              <span class="ml-1" v-if="toolOpinion.hasToBeEffectiveHint">
                <b-icon-question-circle-fill class="question-hint" :id="`popover-target-hasToBeEffective`"></b-icon-question-circle-fill>
              </span>

              <b-popover v-if="toolOpinion.hasToBeEffectiveHint" :target="`popover-target-hasToBeEffective`" triggers="hover" placement="top">
                {{ toolOpinion.hasToBeEffectiveHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <v-select
                id="hasToBeEffectiveLocal"
                :options="effectiveButtons"
                label="Text"
                code="Line"
                v-model="hasToBeEffectiveLocal"
                placeholder="Select Option"
              >
              </v-select>
            </div>
          </div>

          <div class="row  mt-2">
            <label class="col-6">
              <span>Re-challenge possible after how many treatment lines in between?</span>

              <span class="ml-1" v-if="toolOpinion.rechallengePossibleAfterHint">
                <b-icon-question-circle-fill class="question-hint" :id="`popover-target-rechallengePossibleAfter`"></b-icon-question-circle-fill>
              </span>

              <b-popover v-if="toolOpinion.rechallengePossibleAfterHint" :target="`popover-target-rechallengePossibleAfter`" triggers="hover" placement="top">
                {{ toolOpinion.rechallengePossibleAfterHint}}
              </b-popover>
            </label>

            <div class="col-6">
              <v-select
                id="reChallengePossibleAfter"
                :options="availableLines"
                label="Text"
                code="Line"
                v-model="reChallengePossibleAfter"
                placeholder="Select Line"
              >
              </v-select>
            </div>
          </div>
        </div>
        <!--//Treatment History -->

        <!--Disease Status -->
        <app-group
          v-for="(group, index) of toolOpinion.groups"
          :key="index"
          :group="group"
        />
        <!--//Disease Status -->

        <!--2D Matrix -->
        <div class="mb-4">
          <h5>Compound Rating</h5>
          <app-scatter-chart
            :pointsCollection="toolOpinion.getOtherRatingsPointsCollection()"
            :point.sync="toolOpinion.getRatingPoint()"
            :xAxisLabel="efficacyLabel"
            :yAxisLabel="safetyLabel"
            @pointCoordsChanged="pointCoordsChangedHandler"
          />
        </div>
        <!--//2D Matrix -->
      </div>
      <div class="col mb-3">
        <app-submit-button
          :btnClass="'d-block mx-auto px-5'"
          :submitAction="submitToolOpinion"
          :caption="'Submit'"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Watch} from "vue-property-decorator";
import AppToolSelector from "@/components/AppToolSelector.vue";
import AppGroup from "@/components/expert/AppGroup.vue";
import {HttpHandler} from "@/http/HttpHandler";
import AppCompoundRating from "@/components/expert/AppCompoundRating.vue";
import {ToolOpinion} from "@/entities/ToolOpinion";
import AppSubmitButton from "@/components/AppSubmitButton.vue";
import AppDiseaseTreeSelector from "@/components/AppDiseaseTreeSelector.vue";
import AppScatterChart from "@/components/expert/AppScatterChart.vue";
import AppButtonToggle from "@/components/expert/AppButtonToggle.vue";
import AppButtonToggleReChallenge from "@/components/expert/AppButtonToggleReChallenge.vue";
import {Treatment} from "@/entities/Treatment";
import {Group} from "@/entities/questionaire/Group";
import {Property} from "@/entities/questionaire/Property";
import {AnswerVariant} from "@/entities/questionaire/answers/AnswerVariant";
import {BooleanAnswer} from "@/entities/questionaire/answers/BooleanAnswer";
import {SingleItemAnswer} from "@/entities/questionaire/answers/SingleItemAnswer";
import {MultipleItemsAnswer} from "@/entities/questionaire/answers/MultipleItemsAnswer";
import NotificationService from "@/services/NotificationService";
import TnmStageSelector from "@/components/TnmStageSelector.vue";
import { expectedAnswerTypeEffective, expectedAnswerTypeTolerated } from "@/entities/questionaire/answers/ExpectedAnswerTypeReChallenge";
import store from "@/store/index";


@Component({
  components: {
    AppDiseaseTreeSelector,
    AppGroup,
    AppToolSelector,
    AppCompoundRating,
    AppScatterChart,
    AppSubmitButton,
    AppButtonToggle,
    AppButtonToggleReChallenge,
    TnmStageSelector
  }
})
export default class EditTool extends Vue {
  private branchId: number | null = null;
  private toolId: number | null = null;
  private toolOpinion: ToolOpinion | null = null;

  mustBeGivenInLines: { Line: number; Text: string }[] = [];
  reChallengePossibleAfter: { Line: number; Text: string } | null = null;
  hasToBeToleratedLocal: { Line: string; Text: string } | null = null;
  hasToBeEffectiveLocal: { Line: string; Text: string } | null = null;

  mustNotBeGivenAfter: Treatment[] = [];
  mustBeGivenAfter: Treatment[] = [];

  allTreatments: Treatment[] = [];

  notificationService: NotificationService = new NotificationService();

  setConditionProperties() {
    this.mustBeGivenInLines = this.availableLines.filter(lineInfo => {
      let savedLine = this.toolOpinion?.mustBeGivenIn?.find(
        savedLine => savedLine === lineInfo.Line
      );

      if (savedLine !== undefined) {
        return lineInfo;
      }
    });

    this.hasToBeToleratedLocal = null;
    let hasToBeToleratedLocal = this.toleratedButtons.filter(lineInfo => {
      let savedLine =
        this.toolOpinion?.hasToBeTolerated?.toLowerCase() === lineInfo.Line;
      if (savedLine) {
        return lineInfo;
      }
    });

    if (hasToBeToleratedLocal.length) {
      this.hasToBeToleratedLocal = hasToBeToleratedLocal[0];
    }

    this.hasToBeEffectiveLocal = null;
    let hasToBeEffectiveLocal = this.effectiveButtons.filter(lineInfo => {
      let savedLine =
        this.toolOpinion?.hasToBeEffective?.toLowerCase() === lineInfo.Line;
      if (savedLine) {
        return lineInfo;
      }
    });

    if (hasToBeEffectiveLocal.length) {
      this.hasToBeEffectiveLocal = hasToBeEffectiveLocal[0];
    }

    this.reChallengePossibleAfter = null;
    let reChallengePossibleAfter = this.availableLines.filter(lineInfo => {
      let savedLine =
        this.toolOpinion?.rechallengePossibleAfter === lineInfo.Line;
      if (savedLine) {
        return lineInfo;
      }
    });

    if (reChallengePossibleAfter.length) {
      this.reChallengePossibleAfter = reChallengePossibleAfter[0];
    }

    this.mustNotBeGivenAfter = [];
    if (this.toolOpinion && this.toolOpinion.mustNotBeGivenAfter?.length) {
      this.toolOpinion.mustNotBeGivenAfter.forEach(treatId => {
        let existing = this.allTreatments.find(
          (t: Treatment) => t.id === treatId
        );
        if (existing) {
          this.mustNotBeGivenAfter.push(existing);
        }
      });
    }

    this.mustBeGivenAfter = [];
    if (this.toolOpinion && this.toolOpinion.mustBeGivenAfter?.length) {
      this.toolOpinion.mustBeGivenAfter.forEach(treatId => {
        let existing = this.allTreatments.find(
          (t: Treatment) => t.id === treatId
        );
        if (existing) {
          this.mustBeGivenAfter.push(existing);
        }
      });
    }
  }

  addTreatment() {
    if (this.canAddNewTreat) {
      this.mustNotBeGivenAfter.push({
        id: 0,
        name: "Select Treatment",
        ignoreTool: false
      });
    }
  }

  selectTreatment(value: Treatment, treatment: Treatment, index: number) {
    if (!value) {
      this.mustNotBeGivenAfter.splice(index, 1);
    } else {
      treatment.id = value.id;
      treatment.name = value.name;
    }
  }

  addTreatmentMustBeGiven() {
    if (this.canAddNewTreatMustBeGiven) {
      this.mustBeGivenAfter.push({
        id: 0,
        name: "Select Treatment",
        ignoreTool: false
      });
    }
  }

  selectTreatmentMustBeGiven(value: Treatment, treatment: Treatment, index: number) {
    if (!value) {
      this.mustBeGivenAfter.splice(index, 1);
    } else {
      treatment.id = value.id;
      treatment.name = value.name;
    }
  }

  get canAddNewTreat() {
    return !this.mustNotBeGivenAfter.find(treat => treat.id === 0);
  }

  get canAddNewTreatMustBeGiven() {
    return !this.mustBeGivenAfter.find(treat => treat.id === 0);
  }

  get efficacyLabel(): string {
    return "Efficacy";
  }

  get safetyLabel(): string {
    return "Safety";
  }

  get toleratedButtons() {
    return [
      {
        Text: expectedAnswerTypeTolerated.NoAE,
        Line: "noae"
      },
      {
        Text: expectedAnswerTypeTolerated.Grade1AE,
        Line: "grade1ae"
      },
      {
        Text: expectedAnswerTypeTolerated.Grade2AE,
        Line: "grade2ae"
      },
      {
        Text: expectedAnswerTypeTolerated.Grade3AE,
        Line: "grade3ae"
      },
      {
        Text: expectedAnswerTypeTolerated.Grade4AE,
        Line: "grade4ae"
      }
    ]
  };

  get effectiveButtons() {
    return [
      {
        Line: 'cr',
        Text: expectedAnswerTypeEffective.CR
      },
      {
        Line: 'pd',
        Text: expectedAnswerTypeEffective.PD
      },
      {
        Line: 'pr',
        Text: expectedAnswerTypeEffective.PR
      },
      {
        Line: 'sd',
        Text: expectedAnswerTypeEffective.SD
      },
    ];
  }

  get availableLines() {
    return [
      {
        Line: 1,
        Text: "L1"
      },
      {
        Line: 2,
        Text: "L2"
      },
      {
        Line: 3,
        Text: "L3"
      },
      {
        Line: 4,
        Text: "L4"
      },
      {
        Line: 5,
        Text: "L5"
      }
    ];
  }

  @Watch("branchId")
  async onBranchChanged(newBranchId: number) {
    console.log('onBranchChanged', newBranchId);
    this.toolOpinion = null;
    if (!newBranchId) {
      this.toolId = null;
    } else {
      await this.getToolOpinion(newBranchId, this.toolId);
    }

    await this.replaceQueryParams();
  }

  @Watch("toolId")
  async onToolChanged(newToolId: number) {
    await this.getToolOpinion(this.branchId, newToolId);
    await this.replaceQueryParams();
  }

  async replaceQueryParams(): Promise<void> {
    const branchIdEquals = (this.$route.query.branchId || '') === (this.branchId?.toString() || '');
    const toolIdEquals = (this.$route.query.toolId || '') === (this.toolId?.toString() || '');

    if (branchIdEquals && toolIdEquals) return;

    let query = {};
    if (this.branchId) {
      Object.assign(query, { branchId: this.branchId.toString() });
    }

    if (this.toolId) {
      Object.assign(query, { toolId: this.toolId.toString() });
    }

    await this.$router.replace({ name: "Edit treatment", query: query });
  }

  async getToolOpinion(branchId: number | null, toolId: number | null) {
    let httpHandler = new HttpHandler(store);
    this.toolOpinion = await httpHandler.getToolOpinionByBranchIdAndToolId(
      branchId,
      toolId
    );
    if (this.toolOpinion) {
      const tool = this.$store.getters["tool/getToolById"](toolId);
      this.toolOpinion.name = tool?.name ?? "";

      this.setConditionProperties();
    }

    this.allTreatments = this.$store.getters["tool/getAllTools"];
  }

  pointCoordsChangedHandler(pointId: number, coords: [number, number]) {
    const efficacy = coords[0];
    const safety = coords[1];

    if (this.toolOpinion) {
      this.toolOpinion.setSafety(safety);
      this.toolOpinion.setEfficacy(efficacy);
    }
  }

  async submitToolOpinion() {
    if (this.toolOpinion != null) {
      let uncompletedAnswers = [];
      this.toolOpinion.groups.forEach((q: Group) => {
        q.properties.forEach((prop: Property) => {
          prop.failed = false;
          let answer = prop.answer;
          if (answer instanceof BooleanAnswer) {
            if (!answer.isDataCompleted) {
              prop.failed = true;
              uncompletedAnswers.push(answer.text);
            }
          } else if (
            answer instanceof SingleItemAnswer ||
            answer instanceof MultipleItemsAnswer
          ) {
            answer.variants.forEach((a: AnswerVariant) => {
              a.failed = false;
              if (!a.isDataCompleted) {
                prop.failed = true;
                a.failed = true;
                uncompletedAnswers.push(a.text);
              }
            });
          }
        });
      });

      if (uncompletedAnswers.length > 0 && !this.toolOpinion.ignoreTool) {
        this.notificationService.showWarn(
          "Please answer all questions",
          "Incomplete data"
        );
        await Promise.reject();
      } else {
        this.toolOpinion.hasToBeTolerated = this.hasToBeToleratedLocal?.Line;
        this.toolOpinion.hasToBeEffective = this.hasToBeEffectiveLocal?.Line;

        this.toolOpinion.mustBeGivenIn = this.mustBeGivenInLines.map(
          lineInfo => lineInfo.Line
        );
        this.toolOpinion.rechallengePossibleAfter = this.reChallengePossibleAfter?.Line;
        this.toolOpinion.mustNotBeGivenAfter = this.mustNotBeGivenAfter
          .filter(treat => treat.id !== 0)
          .map(treat => treat.id);

        this.toolOpinion.mustBeGivenAfter = this.mustBeGivenAfter
          .filter(treat => treat.id !== 0)
          .map(treat => treat.id);

        let httpHandler = new HttpHandler(store);
        await httpHandler
          .postToolOpinionByBranchIdAndToolId(
            this.branchId,
            this.toolId,
            this.toolOpinion
          )
          .then(() => {
            this.notificationService.showSuccess("Answers successfully saved");
          })
          .catch(e => {
            let errorMessage = e.data.Message;
            let errorTile = "Something goes wrong";
            if (e.data.ExceptionType === "NotCompletedOpinionException") {
              errorMessage = "Please answer all questions";
              errorTile = "Incomplete data";
            }

            this.notificationService.showError(errorMessage, errorTile);
            throw e;
          });
      }
    }
  }

  created() {
    const hasBranchIdParam: boolean =
      !!this.$route.query.branchId &&
      !isNaN(Number(this.$route.query.branchId));
    const hasToolIdParam: boolean =
      !!this.$route.query.toolId && !isNaN(Number(this.$route.query.toolId));

    if (hasBranchIdParam && hasToolIdParam) {
      this.branchId = Number(this.$route.query.branchId);
      this.toolId = Number(this.$route.query.toolId);
    }
  }
}
</script>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/_mixins.scss";

.scrolled {
  overflow-y: scroll;
  height: calc(100vh - 180px);
  overflow-x: hidden;

  @include media-breakpoint-down(xs) {
    height: calc(100vh - 80px);
  }
}

.link {
  color: #007bff;
  cursor: pointer;
}

.disable-link {
  color: grey;
  cursor: unset;
}

.btn-group {
  margin-bottom: 2px;
}
</style>
